export enum FormTypeEnum {
    Appeal = Compliance.FormTypeEnum.Appeal as number,
    // Breaks if you call it "Compliance" because that's also the namespace name
    ComplianceType = Compliance.FormTypeEnum.Compliance as number
}